import Vue from "vue";
import config from "../config.js";
import store from "../store/index";
import events from "../utils/event.js";

const siteConfig = config[process.env.NODE_ENV];
let protocol = "ws:";
if (location.protocol == "https:") {
  protocol = "wss:";
}
let reconnectTimes = 0;
let maxReconnectTimes = 10;

export const startNotice = token => {
  if (!token) {
    return;
  }
  const ws = new WebSocket(`${protocol}//${siteConfig.ws}?token=${token}`);

  ws.onmessage = function(event) {
    let notice = JSON.parse(event.data);
    events.$emit("notice", notice);
    // renderNoticeUrl(notice);
    // store.dispatch("receiveNotice", notice);
    // Toast(notice);
  };
  ws.onopen = evt => {
    console.log("Connection open ...");
    ws.send("Hello WebSockets!");
  };
  ws.onclose = function(event) {
    console.log("Connection closed.");
    if (event.code !== 4123) {
      setTimeout(() => {
        if (ws.readyState == 3) {
          reconnectTimes++;
          console.log("reconnect to ws: " + reconnectTimes);
          startNotice(token);
        }
      }, 3000);
    }
  };

  window.onunload = function() {
    ws.close();
  };
  Vue.prototype.$ws = ws;
};
